import { create } from 'zustand';

const STORAGE_KEY = 'usagi_hub_progress';

interface HubProgressState {
  d1RevealPlayed: boolean;
  d2RevealPlayed: boolean;
}

interface HubProgressActions {
  setD1RevealPlayed: () => void;
  setD2RevealPlayed: () => void;
  reset: () => void;
}

const DEFAULT_STATE: HubProgressState = {
  d1RevealPlayed: false,
  d2RevealPlayed: false,
};

function load(): HubProgressState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<HubProgressState>;
      return {
        d1RevealPlayed: parsed.d1RevealPlayed ?? false,
        d2RevealPlayed: parsed.d2RevealPlayed ?? false,
      };
    }
  } catch {
    /* ignore */
  }
  return DEFAULT_STATE;
}

function persist(state: HubProgressState): void {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      d1RevealPlayed: state.d1RevealPlayed,
      d2RevealPlayed: state.d2RevealPlayed,
    }),
  );
}

export const useHubProgressStore = create<
  HubProgressState & HubProgressActions
>((set) => ({
  ...load(),

  setD1RevealPlayed: () => {
    set((s) => {
      const next = { ...s, d1RevealPlayed: true };
      persist(next);
      return next;
    });
  },

  setD2RevealPlayed: () => {
    set((s) => {
      const next = { ...s, d2RevealPlayed: true };
      persist(next);
      return next;
    });
  },

  reset: () => {
    set(DEFAULT_STATE);
    persist(DEFAULT_STATE);
  },
}));
